var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    _vm._g(
      _vm._b(
        {
          ref: "vform",
          on: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        "v-form",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }